import { styled } from 'styled-components'
import { Breadcrumb } from 'antd'
import WizrFlexLayout from './WizrFlexLayout'
import WizrText from './WizrText'
import WizrIcon from './WizrIcon'

interface IWizrUserJourney {
  userJourney: any
  style?: any
}

const StyledBreadcrumb = styled(Breadcrumb)`
  .ant-breadcrumb-separator {
    display: flex;
    align-items: center;
  }
`

const StyledContainer = styled(WizrFlexLayout)`
  padding: 10px 0px;
  overflow: hidden
`
const styleJourney = (journeys: any) => {
  return journeys?.map((journey: any, key: number) => {
    return { title: <WizrText type='h6'>{journey?.title}</WizrText> }
  })
}

const WizrUserJourney = ({ userJourney,style }: IWizrUserJourney): JSX.Element => {
  const styledUserJourneys = styleJourney(userJourney)
  return (
    <StyledContainer style={style}>
      <StyledBreadcrumb
        items={styledUserJourneys}
        separator={<WizrIcon name='breakCrumbArrow' />}
      />
    </StyledContainer>
  )
}

export default WizrUserJourney
